module.exports = __webpack_public_path__ + "img/three.a972368a.png";